/** Avoid prepending "/" to hashes or absolute URLs — e.g. "#contact-us" must not become "/#contact-us". */
export function legalNavHref(href: string): string {
  const h = href.trim();
  if (h.startsWith('#') || h.startsWith('/') || /^[a-z][a-z0-9+.-]*:/i.test(h)) return h;
  return `/${h}`;
}
